module.exports = __webpack_public_path__ + "static/media/03.54a01564.jpg";